import { environment } from 'src/environment/environment';
import { Component, inject } from '@angular/core';
import { GetAmountByPRRNDTO, PaymentResponseDTO, RazorpayCreateOrderDTO, RazorpayOrderItem } from './razorpay.interface';
import { RazorpayServices } from './razorpay.services';
import { UserLoginService } from 'src/app/login/userlogin.service';
import { LoanApplicationService } from '../loan-applications/loan-applications.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuickLoanData } from '../quick-loan-process/quick-loan.interface';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GetAmountByPRRNResponseDTO, ReceiptMasterCreateRequestDTO } from '../receipt-master/receiptMaster.interface';
import { PaylaterReceiptMasterService } from '../receipt-master/receiptMaster.service';
import { PaymentTransactionsService } from '../Interface & Service/payment-transactions/payment-transactions.services';
import { PaymentTransactionsCreateRequestDTO, PaymentTransactionsUpdateRequestDTO } from '../Interface & Service/payment-transactions/payment-transactions.interface';
import { SchoolInvoiceMasterService } from 'src/app/School/EndUser/receipt-master/receipt-master.service';
import { SchoolInvoiceMasterCreateRequestDTO, SchoolInvoiceMasterUpdateRequestDTO } from 'src/app/School/EndUser/receipt-master/receipt-master.interface';
import { SM_SocietyInvoiceMasterService } from 'src/app/housing-society/Interface & Service/invoice-master/invoice-master.service';

declare var Razorpay: any;

@Component({
  selector: 'app-razorpay',
  templateUrl: './razorpay.component.html',
  styleUrls: ['./razorpay.component.css']
})
export class RazorpayComponent {

  //services
  PaymentTransactionsService = inject(PaymentTransactionsService)
  razorpayServices = inject(RazorpayServices);
  paylaterReceiptMasterServices = inject(PaylaterReceiptMasterService)
  razorPayAPIKeyId = environment.razorPayAPIKeyId;
  User = inject(UserLoginService).User()
  loanApplicationService = inject(LoanApplicationService)
  route = inject(ActivatedRoute);
  router = inject(Router)
  toastr = inject(ToastrService);
  private destroy$ = new Subject<void>();
  schoolInvoiceMasterService = inject(SchoolInvoiceMasterService)
  housingSocietyReceiptMasterService = inject(SM_SocietyInvoiceMasterService)

  //flags
  paymentStarted : boolean = false
  scriptLoaded = false
  createOrderReponse!: RazorpayOrderItem
  PaymentResponseDTO: PaymentResponseDTO | null = null;
  quickLoanData: QuickLoanData = {
    prrn: '',
    userId: 0,
    subUserId: 0,
    businessId: 0,
    loanamt: 0,
    productcode: '',
    moduleName: '',
    emiTenure: 0
  };

  getByPRRNItemData!: GetAmountByPRRNResponseDTO;

  ngOnInit() {
    this.loadRazorpayScript().then(() => {
      this.scriptLoaded = true;
      console.log('Razorpay script loaded!');
    });

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        const state: any = history.state || {};

        /*
         * FE-006 FIX
         *
         * Security-sensitive identifiers are NOT accepted from the URL.
         *
         * - userId always comes from the authenticated logged-in user.
         * - subUserId / businessId are accepted only from router state as a
         *   short-lived UI context until the backend PRRN resolver returns the
         *   canonical values.
         * - loan amount is NEVER taken from URL/router state for payment.
         *   The authoritative amount is loaded by ReceiptMaster_GetAmountByPRRN.
         * - dummy fallback IDs/amount have been removed completely.
         *
         * IMPORTANT:
         * The backend ReceiptMaster_GetAmountByPRRN endpoint must also verify
         * that the authenticated caller is allowed to use this PRRN.
         */

        const prrn = String(
          params['prrn'] ??
          state.prrn ??
          ''
        ).trim();

        const productcode = String(
          params['productcode'] ??
          state.productcode ??
          ''
        ).trim();

        const moduleName = String(
          params['moduleName'] ??
          state.moduleName ??
          ''
        ).trim();

        const stateSubUserId = Number(state.subUserId ?? 0);
        const stateBusinessId = Number(state.businessId ?? 0);
        const stateEmiTenure = Number(state.emiTenure ?? 0);

        this.quickLoanData = {
          prrn: prrn,
          userId: Number(this.User.userId || 0),
          subUserId:
            Number.isFinite(stateSubUserId) && stateSubUserId > 0
              ? stateSubUserId
              : 0,
          businessId:
            Number.isFinite(stateBusinessId) && stateBusinessId > 0
              ? stateBusinessId
              : 0,
          loanamt: 0,
          productcode: productcode,
          moduleName: moduleName,
          emiTenure:
            Number.isFinite(stateEmiTenure) && stateEmiTenure > 0
              ? stateEmiTenure
              : 0,
        };

        if (!this.quickLoanData.prrn || !this.quickLoanData.moduleName) {
          this.toastr.error(
            'Invalid payment link. Please start payment again from the original bill.'
          );
          return;
        }

        if (!this.quickLoanData.userId) {
          this.toastr.error(
            'Unable to identify the logged-in user. Please login again.'
          );
          return;
        }
      });

    // this.getAmountByPRRNData()
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadRazorpayScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve();
      script.onerror = () => reject('Razorpay SDK failed to load.');
      document.body.appendChild(script);
    });
  }

  onPayment() {
    if (this.paymentStarted) {
      return;
    }

    if (!this.quickLoanData.prrn || !this.quickLoanData.moduleName) {
      this.toastr.error(
        'Invalid payment context. Please start payment again from the original bill.'
      );
      return;
    }

    this.paymentStarted = true;
    this.getAmountByPRRNData();
  }

  createOrder(amount: number) {
    const data: RazorpayCreateOrderDTO = {
      amount: amount,
      currency: 'INR',
      receipt: "receipt_" + Math.floor(Math.random() * 1000000000),
      notes: {
        notes_key_1: 'hello',
        notes_key_2: 'hello'
      }
    }

    this.razorpayServices.Razorpay_CreateOrder(data).subscribe({
      next: (res: RazorpayOrderItem) => {
        if (res.isStatusCode === 200) {
          this.createOrderReponse = res
          this.paymentStarted = false;
          this.openRazorpayCheckout()
        }
        else if (res.isStatusCode === 400) {
          this.paymentStarted = false;
          const description = res.error?.description;

          switch (description) {
            case 'Order amount less than minimum amount allowed':
              this.toastr.error(res.error?.description || 'the Amount is too low');
              break;

            case 'syntax error but provided ,\n  \"curre...':
              this.toastr.error(res.error?.reason || 'Syntax Error');
              break;

            case 'currency: cannot be blank.':
              this.toastr.error(res.error?.description || 'Currency cannot be blank');
              break;

            case 'Amount exceeds maximum amount allowed.':
              this.toastr.error(res.error?.description || 'Amount limit exceeds/Amount is too high to begin')
              break;
          }
        }
        // this.createOrderReponse = res
        // this.openRazorpayCheckout()
      },
      error: (err) => {
        this.paymentStarted = false;
        console.error('Razorpay order creation failed: ', err);
        this.toastr.error('Unable to create payment order');
      }
    })
  }

  PayIdReqObj = {
    payId: '',
    orderId: ''
  }

  ReceiptMasterObj: ReceiptMasterCreateRequestDTO = {
    receiptDate: new Date(),
    prrn: '',
    receiptAmount: 0,
    moduleName: '',
    otherDetail1: '',
    otherDetail2: '',
    otherDetail3: '',
    otherDetail4: '',
    otherDetail5: '',
    otherDetail6: '',
    actionUser: this.User.userId.toString(),
    orderId: '',
    paymentId: '',
    mode: '',
    status: '',
    masterId: 0,
    masterType: ''
  }

  updateReceiptMasterRStatusObj: SchoolInvoiceMasterUpdateRequestDTO = {
    invoiceId: 0,
    invoiceDate: '',
    invoiceNumber: '',
    prrn: '',
    invoiceAmount: 0,
    status: '',
    schoolId: 0,
    billedTo: 0,
    remarks: '',
    otherDetail1: '',
    otherDetail2: '',
    otherDetail3: '',
    otherDetail4: '',
    otherDetail5: '',
    otherDetail6: '',
    isActive: 1,
    actionUser: this.User.userId.toString(),
  }

  updateReceiptMasterRStatus() {
    this.updateReceiptMasterRStatusObj.invoiceId = this.getByPRRNItemData.InvoiceId ?? 0;
    this.updateReceiptMasterRStatusObj.invoiceNumber = this.getByPRRNItemData.InvoiceNumber ?? '';
    this.updateReceiptMasterRStatusObj.invoiceDate = this.getByPRRNItemData.InvoiceDate?.toString() ?? '';
    this.updateReceiptMasterRStatusObj.invoiceAmount = this.getByPRRNItemData.InvoiceAmount ?? 0;
    this.updateReceiptMasterRStatusObj.billedTo = this.getByPRRNItemData.BilledTo ?? 0;
    this.updateReceiptMasterRStatusObj.prrn = this.getByPRRNItemData.PRRN;
    this.updateReceiptMasterRStatusObj.remarks = this.getByPRRNItemData.Remarks ?? '';
    this.updateReceiptMasterRStatusObj.otherDetail1 = this.getByPRRNItemData.otherDetail1 ?? '';
    this.updateReceiptMasterRStatusObj.otherDetail2 = this.getByPRRNItemData.otherDetail2 ?? '';
    this.updateReceiptMasterRStatusObj.otherDetail3 = this.getByPRRNItemData.otherDetail3 ?? '';
    this.updateReceiptMasterRStatusObj.otherDetail4 = this.getByPRRNItemData.otherDetail4 ?? '';
    this.updateReceiptMasterRStatusObj.otherDetail5 = this.getByPRRNItemData.otherDetail5 ?? '';
    this.updateReceiptMasterRStatusObj.otherDetail6 = this.getByPRRNItemData.otherDetail6 ?? '';
    if (this.quickLoanData.moduleName.toLowerCase() === 'school') {
      this.schoolInvoiceMasterService.SchoolInvoiceMaster_Update(this.updateReceiptMasterRStatusObj).subscribe({
        next: (res) => {
          console.log(res)
          this.toastr.success('School receipt Master was updated')
        }
      })
    }
    else if(
      this.quickLoanData.moduleName.toLowerCase() === 'housingsociety' ||
      this.quickLoanData.moduleName.toLowerCase() === 'society'
    ){
      /*
       * FE-007 FIX
       *
       * Housing Society was previously a commented-out no-op.
       * Keep the existing post-payment flow, but update the Society
       * InvoiceMaster through the already injected
       * SM_SocietyInvoiceMasterService.
       *
       * Do not reuse the School DTO here because Society InvoiceMaster
       * requires Society/Building/BilledTo fields.
       */
      const response: any = this.getByPRRNItemData as any;

      const paymentStatus = String(
        this.PaymentResponseDTO?.status ||
        this.updateReceiptMasterRStatusObj.status ||
        ''
      )
        .trim()
        .toLowerCase();

      const societyInvoiceStatus =
        paymentStatus === 'captured' ||
        paymentStatus === 'paid' ||
        paymentStatus === 'success' ||
        paymentStatus === 'completed' ||
        paymentStatus === 'complete'
          ? 'Paid'
          : (
              this.PaymentResponseDTO?.status ||
              this.updateReceiptMasterRStatusObj.status ||
              'Pending'
            );

      const societyInvoicePayload: any = {
        invoiceId: Number(
          response.InvoiceId ??
          response.invoiceId ??
          0
        ),

        buildingId: Number(
          response.BuildingId ??
          response.buildingId ??
          0
        ),

        societyId: Number(
          response.SocietyId ??
          response.societyId ??
          response.BusinessId ??
          response.businessId ??
          response.otherDetail1 ??
          response.OtherDetail1 ??
          this.quickLoanData.businessId ??
          0
        ),

        billedTo: Number(
          response.BilledTo ??
          response.billedTo ??
          response.SubUserId ??
          response.subUserId ??
          response.otherDetail2 ??
          response.OtherDetail2 ??
          this.quickLoanData.subUserId ??
          0
        ),

        dueDate:
          response.DueDate ??
          response.dueDate ??
          null,

        invoiceDate:
          response.InvoiceDate ??
          response.invoiceDate ??
          null,

        invoiceNumber:
          response.InvoiceNumber ??
          response.invoiceNumber ??
          '',

        prrn:
          response.PRRN ??
          response.prrn ??
          this.quickLoanData.prrn ??
          '',

        invoiceAmount: Number(
          response.InvoiceAmount ??
          response.invoiceAmount ??
          0
        ),

        status: societyInvoiceStatus,

        remarks:
          response.Remarks ??
          response.remarks ??
          'Payment completed via Razorpay',

        otherDetail1:
          response.otherDetail1 ??
          response.OtherDetail1 ??
          '',

        otherDetail2:
          response.otherDetail2 ??
          response.OtherDetail2 ??
          '',

        otherDetail3:
          this.PaymentResponseDTO?.id ??
          response.otherDetail3 ??
          response.OtherDetail3 ??
          '',

        otherDetail4:
          this.PaymentResponseDTO?.order_id ??
          response.otherDetail4 ??
          response.OtherDetail4 ??
          '',

        otherDetail5:
          response.otherDetail5 ??
          response.OtherDetail5 ??
          '',

        otherDetail6:
          response.otherDetail6 ??
          response.OtherDetail6 ??
          'Razorpay',

        isActive: 1,
        actionUser: this.User.userId.toString(),
      };

      /*
       * Required by sm.InvoiceMaster_Update.
       * Do not send an incomplete Society update because that could
       * overwrite the invoice with invalid IDs.
       */
      if (
        !societyInvoicePayload.invoiceId ||
        !societyInvoicePayload.societyId ||
        !societyInvoicePayload.buildingId ||
        !societyInvoicePayload.billedTo
      ) {
        console.error(
          'Society invoice update skipped because required context is missing',
          societyInvoicePayload
        );

        this.toastr.error(
          'Payment succeeded but Society invoice context is incomplete. Please verify the payment from Society admin.'
        );

        return;
      }

      this.housingSocietyReceiptMasterService
        .SocietyInvoiceMaster_Update(societyInvoicePayload)
        .subscribe({
          next: (res) => {
            console.log('Society invoice updated: ', res);
            this.toastr.success('Society invoice was updated');
          },
          error: (err) => {
            console.error('Society invoice update failed: ', err);
            this.toastr.error(
              'Payment succeeded but Society invoice status update failed'
            );
          }
        });
    }
    else if(this.quickLoanData.moduleName.toLowerCase() === 'realestate'){
      //************************************ */
    }
    else if(this.quickLoanData.moduleName.toLowerCase() === 'hospital'){
      //************************************ */
    }
    console.log('update receipt mastere was called')
  }

  payIdStatus() {
    console.log(this.PayIdReqObj)
    this.razorpayServices.Razorpay_PayId_Create(this.PayIdReqObj).subscribe({
      next: (res) => {
        if (res.isStatusCode === 200) {
            this.PaymentResponseDTO = res
          // this.ReceiptMasterObj.status = res.status
          // this.recipetMasterCreate()
          this.toastr.success(res.description?.toString())
          this.updateReceiptMasterRStatusObj.status = res.status;
          this.updateReceiptMasterRStatus()
          this.paymentTransactionsAPI('edit')
          setTimeout(() => {
            window.open('', '_self');
            window.close();
          }, 3000);
        }
        else if (res.isStatusCode === 400) {
          this.toastr.error(res.error?.description || 'error 400')
        }
        else if (res.isStatusCode === 401) {
          this.toastr.error(res.error?.description || 'error 401')
        }
        else if (res.isStatusCode === 403) {
          this.toastr.error(res.error?.description || 'error 403')
        }
        else if (res.isStatusCode === 404) {
          this.toastr.error(res.error?.description || 'error 404')
        }
        else if (res.isStatusCode === 429) {
          this.toastr.error(res.error?.description || 'error 429')
        }
        this.ReceiptMasterObj.status = res.status 
        this.ReceiptMasterObj.mode = res.method
        this.ReceiptMasterObj.paymentId = res.id
        this.ReceiptMasterObj.orderId = res.order_id
        this.ReceiptMasterObj.masterId = this.quickLoanData.businessId
        this.ReceiptMasterObj.masterType = this.quickLoanData.moduleName
        this.recipetMasterCreate()
      },
      error: (err) => {
        console.log("Error: ", err)
      }
    })

  }

  paymentTransactionsAPI(mode: string){
    const payload: PaymentTransactionsCreateRequestDTO | PaymentTransactionsUpdateRequestDTO = {
      parentTransactionId: 0,
      referenceTransactionId: 0,
      loanId: 0,
      userId: Number(this.quickLoanData.userId),
      transactionType: this.PaymentResponseDTO?.method ?? '',
      paymentMethod: this.PaymentResponseDTO?.method ?? '',
      transactionAmount: this.PaymentResponseDTO?.amount ?? 0,
      currencyCode: this.PaymentResponseDTO?.currency ?? '',
      statusCode: 'Initiated',
      moduleType: this.quickLoanData.moduleName,
      moduleEntityId: 0,
      businessId: Number(this.quickLoanData.businessId),
      actionUser: this.User.userId.toString(),
      otherDetail1: '',
      otherDetail2: '',
      otherDetail3: '',
      otherDetail4: '',
      otherDetail5: '',
      otherDetail6: '',
      isActive: 1,
      transactionId:0,
      
    }
    if(mode === 'create'){
      this.PaymentTransactionsService.PaymentTransactions_Create(payload).subscribe({
        next: (res)=> {
          console.log('payment Transactions res: ', res)
        },
        error: (err)=> {
          console.log('Payment Transactions error: ', err)
        }
      })
    }
    else{
      payload.statusCode = this.PaymentResponseDTO?.status ?? 'pending'
      this.PaymentTransactionsService.PaymentTransactions_Update(payload).subscribe({
        next: (res)=> {
          console.log('Payment Transactions Update res: ', res)
        },
        error: (err)=> {
          console.log('Payment Transactions Update error: ', err)
        }
      })
    }
  }

  recipetMasterCreate() {
    this.paylaterReceiptMasterServices.ReceiptMaster_Create(this.ReceiptMasterObj).subscribe({
      next: (res) => {
        console.log(res)
      },
      error: (err) => {
        console.log("Error: ", err)
      }
    })
  }

  openRazorpayCheckout(): void {
    if (!this.scriptLoaded) {
      alert('Razorpay SDK not loaded yet!');
      return;
    }

    console.log(this.createOrderReponse)
    const options = {
      key: this.razorPayAPIKeyId,
      amount: this.createOrderReponse.amount,
      currency: this.createOrderReponse.currency,
      name: this.User.userName,                           //Change the logic here, and add the name of the business
      description: this.quickLoanData.moduleName + ' charges',
      order_id: this.createOrderReponse.id,
      handler: (response: any) => {
        this.PayIdReqObj.orderId = response.razorpay_order_id;
        this.PayIdReqObj.payId = response.razorpay_payment_id
        this.payIdStatus()
        console.log('Payment success', response);    //here i will get the pay_id to verify the payment success or to fetch the payment detail
      },
      prefill: {
        name: this.User.userName,
        email: this.User.emailId,
        contact: this.User.mobileNo
      },
      theme: { color: '#3399cc' }
    };

    const rzp = new Razorpay(options);
    rzp.on('payment.failed', (response: any) => {
      console.error('Payment failed', response.error.description);
    });

    rzp.open();
  }

  getAmountByPRRNData() {
    if (!this.quickLoanData.prrn || !this.quickLoanData.moduleName) {
      this.paymentStarted = false;
      this.toastr.error(
        'Invalid payment context. Please start payment again from the original bill.'
      );
      return;
    }

    const data: GetAmountByPRRNDTO = {
      prrn: this.quickLoanData.prrn,
      moduleName: this.quickLoanData.moduleName
    }

    this.ReceiptMasterObj.prrn = data.prrn

    this.paylaterReceiptMasterServices
      .ReceiptMaster_GetAmountByPRRN(data)
      .subscribe({
        next: (response) => {
          this.getByPRRNItemData = response

          /*
           * FE-006:
           * Amount comes only from the backend PRRN lookup.
           * Never trust loanamt from URL/router state.
           */
          const serverAmount = Number(response.InvoiceAmount || 0);

          if (!serverAmount || serverAmount <= 0) {
            this.paymentStarted = false;
            this.toastr.error('Invalid payment amount received from server');
            return;
          }

          this.quickLoanData.loanamt = serverAmount;

          /*
           * Prefer server-resolved identifiers when the PRRN response exposes
           * them. BilledTo is already part of the response used elsewhere in
           * this component and is therefore safer than a URL-controlled ID.
           */
          const serverResponse: any = response as any;

          const serverSubUserId = Number(
            serverResponse.BilledTo ??
            serverResponse.billedTo ??
            serverResponse.SubUserId ??
            serverResponse.subUserId ??
            0
          );

          const serverBusinessId = Number(
            serverResponse.BusinessId ??
            serverResponse.businessId ??
            serverResponse.SchoolId ??
            serverResponse.schoolId ??
            serverResponse.SocietyId ??
            serverResponse.societyId ??
            serverResponse.HospitalId ??
            serverResponse.hospitalId ??
            0
          );

          if (serverSubUserId > 0) {
            this.quickLoanData.subUserId = serverSubUserId;
          }

          if (serverBusinessId > 0) {
            this.quickLoanData.businessId = serverBusinessId;
          }

          const amountConverted = serverAmount * 100;

          this.ReceiptMasterObj.receiptAmount = amountConverted
          this.ReceiptMasterObj.moduleName = response.ModuleName

          this.paymentTransactionsAPI('create');
          this.createOrder(amountConverted)
        },
        error: (err) => {
          this.paymentStarted = false;
          console.error('Error fetching the Amount: ', err)
          this.toastr.error(
            'Unable to validate payment reference. Please try again.'
          );
        }
      })
  }
}
